import { AuthContext } from "@/components/AuthContext";
import React from "react";

export default function useAuth() {
    return React.useContext(AuthContext);
}
